





























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import axios from "axios";

@Component
export default class CVDialog extends Vue {
  private dialog: boolean;
  private files: any;

  constructor() {
    super();
    this.dialog = false;
    this.files = null;
  }

  close() {
    this.dialog = false;
  }

  upload() {
    // console.log(this.files);
    // if (this.files.length > 0) {
      let formData = new FormData();
    //   for (let file of this.files) {
        formData.append("files", this.files, this.files.name);
        //  console.log(formData.getAll("files"));
    //   }

        axios
          .post("http://localhost:8181/UploadCV", formData)
          .then(response => {
            // console.log("Success!");
            // console.log({ response });
          })
          .catch(error => {
            // console.log({ error });
          });

      //   var payload = {
      //     formData: formData
      //   };
      //   console.log(payload.formData)
      //   user
      //     .dispatchUploadCV(this["$store"], payload)
      //     .then(() => {
      //       bus.$emit(
      //         "successfullOperation",
      //         "Curriculum Vitae caricato con successo"
      //       );
      //     })
      //     .catch(error => {
      //       if (error.response.status === 403) {
      //         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
      //         this["$router"].push("/login");
      //       } else {
      //         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
      //       }
      //     });
    // }
  }
}
